<div>
    <div class="panel-header" (click)="toggle()" [attr.aria-expanded]="!isCollapsed">
        <div class="row h-100 align-items-center">
            <div class="col">
                <span class="fkm-chevron"><i class="far fa-chevron-down"
                        [ngClass]="{'panel-collapsed': !isCollapsed}"></i></span>
                <span translate="{{header}}"></span>
            </div>
            <ng-container>
                <ng-content select="[headerContent]"></ng-content>
            </ng-container>
        </div>
    </div>
    <div [ngbCollapse]="isCollapsed">
        <ng-content></ng-content>
    </div>
</div>